import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import restService from "../rest-service/RestService";
import { IFormula, IObjectPropertiesDeviceModel, IObjectPropertiesTankBatteryModel, IObjectPropertiesTankModel, IObjectPropertiesWellModel, IObjectPropertyListModel, ITagProperties } from "./Models";

interface ISaveWellParams {
    groupID: number;
    wellID: number
}

const PropertiesDataService = {

    getPropertyData: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        signal?: AbortSignal
    ): Promise<IObjectPropertiesDeviceModel |
        IObjectPropertiesTankModel |
        IObjectPropertiesTankBatteryModel |
        IObjectPropertiesWellModel |
        ITagProperties
        > {

        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/properties`;

        const response = await restService.get<IObjectPropertiesDeviceModel |
        IObjectPropertiesTankModel |
        IObjectPropertiesTankBatteryModel |
        IObjectPropertiesWellModel |
        ITagProperties>(path, signal);

        return response.data;
    },
    saveProperties: async (contextGroupID: number, eLynxObject: IeLynxObject, data: IObjectPropertiesDeviceModel |
        IObjectPropertiesTankModel |
        IObjectPropertiesTankBatteryModel |
        IObjectPropertiesWellModel |
        ITagProperties): Promise<void> => {



        const path = eLynxObject.objectType === eLynxObjectTypeEnum.Well ? 
                            `/wells` :
                            `/groups/${contextGroupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/properties`;

        switch (eLynxObject.objectType) {

            case eLynxObjectTypeEnum.Device:
            case eLynxObjectTypeEnum.Tank:
            case eLynxObjectTypeEnum.TankBattery:
            case eLynxObjectTypeEnum.Tag:

                await restService.post<IObjectPropertiesDeviceModel |
                IObjectPropertiesTankModel |
                IObjectPropertiesTankBatteryModel |
                ITagProperties, void>(path, data);  
                break;

            case eLynxObjectTypeEnum.Well:
                const wellParms: ISaveWellParams = {
                    groupID: contextGroupID,
                    wellID: eLynxObject.id
                };

                const wellProperties = data as IObjectPropertiesWellModel;

                await restService.post<IObjectPropertiesWellModel, void, ISaveWellParams>(path, wellProperties, undefined, undefined, wellParms);  

                break;

            default:
                throw new Error(`getPropertyData not implemented for ${eLynxObject.objectType}`);
        }
    },
    getPropertyLists: async (
        groupID: number,
        eLynxObject: IeLynxObject,
        signal?: AbortSignal
    ): Promise<IObjectPropertyListModel> => {

        const path: string = `groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/propertylists`;
        const result = await restService.get<IObjectPropertyListModel>(path, signal);

        return result.data;
    },
    saveFormula: async(contextGroupID: number,
        formula: IFormula): Promise<IFormula> => {

        const path = `groups/${contextGroupID}/formulae`;            
        const result = await restService.post<IFormula, IFormula>(path, formula);
        return result.data;

    }

};

export default PropertiesDataService;